import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
import { FeatureReels } from "./FeatureReels";
import { Container, Text, TextStyle } from "pixi.js";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { addToTitanSpineSlot, delayFor, getTitanSpineSlot, SpineComplete, updateResponsiveSpineSlotsChildren } from "../../../../../utils/SpineUtils";
import gsap from "gsap";
import { MouseUtil } from "@lib/titan2/dist/util/view/MouseUtil";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { GlitchFilter } from "pixi-filters";
import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { SoundEvent } from "../../../../../controller/event/GameEvent";
import { ParticleEmitter } from "@lib/titan2/dist/game/manager/data/ParticleEmitter";
import { LinkedListContainer } from "@pixi/particle-emitter";
import { Service } from "@lib/titan2-slingo/dist/api/Service";
import { glitchFadeIn, glitchFadeOut } from "./GlitchFilterTween";
import { ViewUtils } from "@lib/titan2/dist/util/view/ViewUtils";
import { Trail } from "./Trail";
import { OrientationType } from "@lib/titan2/dist/game/renderer/constant/RendererConstants";
import { MouseBlocker } from "@lib/titan2/dist/game/control/MouseBlocker";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { GameClawpawtraSoundEvents } from "../../../../../controller/event/GameSountEvent";
const TWEEN_TO_CAT_MIDPOINT = { x: 0, y: -380 };
var RespinState;
(function (RespinState) {
    RespinState["DISABLED"] = "DISABLED";
    RespinState["TRANSITIONING_IN"] = "TRANSITIONING_IN";
    RespinState["ENABLED"] = "ENABLED";
    RespinState["TRANSITIONING_OUT"] = "TRANSITIONING_OUT";
})(RespinState || (RespinState = {}));
export class FeatureGoldFish extends AbstractGameView {
    constructor(factory, landscapeProperties, portraitProperties) {
        super(factory, landscapeProperties, portraitProperties);
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(FeatureGoldFishEvents.FEATURE_PRESENT, this.featurePresent);
        this.registerGame(FeatureGoldFishEvents.START, this.start);
        this.registerGame(FeatureGoldFishEvents.START_GAME_INTRO, this.gameIntro);
        this.registerGame(FeatureGoldFishEvents.CLEAR, this.clear);
        this.registerGame(FeatureGoldFishEvents.SPIN, this.spin);
        this.registerGame(FeatureGoldFishEvents.REVEAL_REEL_PAYOUTS, this.revealReelPayouts);
        this.registerGame(FeatureGoldFishEvents.COLLECT_REEL_PAYOUT, this.collectReelPayout);
        this.registerGame(FeatureGoldFishEvents.COLLECT_CAT_FROM_REEL, this.goldFishCollectedFromReel);
        this.registerGame(FeatureGoldFishEvents.COLLECT_WATCH_FROM_REEL, this.collectBlueFishFromReel);
        this.registerGame(FeatureGoldFishEvents.DISTRIBUTE_MULTIPLIER, this.distributeMultiplier);
        this.registerGame(FeatureGoldFishEvents.ENABLE_LOCKS, this.enableLocks);
        this.registerGame(FeatureGoldFishEvents.EXIT_RESPINS, this.exitRespins);
        this.registerGame(FeatureGoldFishEvents.CLEAR_LOCKS, this.clearLocks);
        this.registerGame(FeatureGoldFishEvents.UPDATE_SPIN_COUNT, this.updateSpinCount);
        this.registerGame(FeatureGoldFishEvents.UPDATE_WIN_COUNT, this.updateWinCount);
        this.registerGame(FeatureGoldFishEvents.REVEAL_PRIZES, this.revealPrizes);
    }
    async create() {
        super.create();
        const backgroundBlocker = new MouseBlocker(new MouseBlockerProperties(0x370723, 1));
        this.addChild(backgroundBlocker);
        this.interactive = true;
        this.background = TitanSprite.createSprite(this, "background", this.landscapeProperties.background, this.portraitProperties.background);
        this.respinBackground = TitanSprite.createSprite(this, "respinBackground", this.landscapeProperties.respinBackground, this.portraitProperties.respinBackground);
        this.respinBackground.alpha = 0;
        this.cats = [];
        this.catSpaceContainer = ViewUtils.createContainer(this, "cat-space-container");
        this.catSpaceOverlayContainer = ViewUtils.createContainer(undefined, "cat-space-container");
        this.cats = [this.createCat()];
        this.handleResize();
        this.prizeCat = TitanSpine.createSpine(null, "prizeCat", this.landscapeProperties.prizeCat, this.portraitProperties.prizeCat);
        this.yarnMask = TitanSprite.createSprite(null, "yarnMask", this.landscapeProperties.yarnMask, this.portraitProperties.yarnMask);
        this.balls = [];
        this.balls = this.landscapeProperties.balls.map((ballProperties, index) => {
            const ball = TitanSpine.createSpine(this, `ball-${index}`, ballProperties, this.portraitProperties.balls[index]);
            MouseUtil.addMouseDown(ball, () => this.dispatchGame(new EventObject(FeatureGoldFishEvents.PICK_SELECTED.getType(), { index })), null);
            return ball;
        });
        this.reels = this.addChild(new FeatureReels(this.factory, this.landscapeProperties.reelsProperties, this.portraitProperties.reelsProperties));
        this.paytableIcons = this.landscapeProperties.paytableIcons.map((iconProperties, index) => {
            const icon = TitanSprite.createSprite(this, `icon-${index}`, iconProperties, this.portraitProperties.paytableIcons[index]);
            return icon;
        });
        this.paytableWatchValue = TitanText.createField(this, this.landscapeProperties.payTableValueWatch, this.portraitProperties.payTableValueWatch);
        this.paytableSnuffboxValue = TitanText.createField(this, this.landscapeProperties.payTableValueSnuffbox, this.portraitProperties.payTableValueSnuffbox);
        this.paytableHairclipValue = TitanText.createField(this, this.landscapeProperties.payTableValueHairclip, this.portraitProperties.payTableValueHairclip);
        this.paytableTunaValue = TitanText.createField(this, this.landscapeProperties.payTableValueTuna, this.portraitProperties.payTableValueTuna);
        this.paytableWatchValue.setText("x1");
        this.paytableSnuffboxValue.setText("x2");
        this.paytableHairclipValue.setText("x3");
        this.paytableTunaValue.setText("x5");
        this.paytableWatchValue.alpha = 0;
        this.paytableSnuffboxValue.alpha = 0;
        this.paytableHairclipValue.alpha = 0;
        this.paytableTunaValue.alpha = 0;
        this.paytableText = [this.paytableWatchValue, this.paytableSnuffboxValue, this.paytableHairclipValue, this.paytableTunaValue];
        this.respinWatch = TitanSpine.createSpine(this, "respinWatch", this.landscapeProperties.respinWatch, this.portraitProperties.respinWatch);
        this.respinWatch.visible = false;
        this.respinTitle = TitanText.createField(this, "respinTitle", this.landscapeProperties.respinTitle, this.portraitProperties.respinTitle);
        this.respinMultiplierBackground = TitanSprite.createSprite(this, "respinMultiplierBackground", this.landscapeProperties.respinMultiplierBackground, this.portraitProperties.respinMultiplierBackground);
        this.respinMultiplierValue = TitanText.createField(this.respinMultiplierBackground, this.landscapeProperties.respinMultiplierValue, this.portraitProperties.respinMultiplierValue);
        this.respinMultiplierValue.setText("2x", true);
        this.respinMultiplierBackground.visible = false;
        this.respinTitle.setText("RESPIN", true);
        this.respinTitle.alpha = 0;
        const spinCountPanel = TitanSprite.createSprite(this, "spinCountPanel", this.landscapeProperties.spinCountPanel, this.portraitProperties.spinCountPanel);
        const spinCountLabel = TitanText.createField(spinCountPanel, this.landscapeProperties.spinCountLabel, this.portraitProperties.spinCountLabel);
        spinCountLabel.setText("BONUS SPINS", true);
        this.spinCount = TitanText.createField(spinCountPanel, this.landscapeProperties.spinCountValue, this.portraitProperties.spinCountValue);
        const winCountPanel = TitanSprite.createSprite(this, "winCountPanel", this.landscapeProperties.winCountPanel, this.portraitProperties.winCountPanel);
        const winCountLabel = TitanText.createField(winCountPanel, this.landscapeProperties.winCountLabel, this.portraitProperties.winCountLabel);
        winCountLabel.setText("TOTAL WIN", true);
        this.winCount = TitanText.createField(winCountPanel, this.landscapeProperties.winCountValue, this.portraitProperties.winCountValue);
        this.spinWinValue = TitanText.createField(this, this.landscapeProperties.spinWinValue, this.portraitProperties.spinWinValue);
        this.spinWinValue.setText("", true);
        this.spinWinValue.getPixiText()?.scale.set(0);
        TitanSprite.createSprite(this, "logo", this.landscapeProperties.logoProperties, this.portraitProperties?.logoProperties);
        this.addChild(this.catSpaceOverlayContainer);
        this.helpButton = this.addChild(this.factory.createBonusHelp());
        this.glitchFilterHideCat = new GlitchFilter({ fillMode: GlitchFilter.TRANSPARENT, slices: 0, offset: 0 });
        this.glitchFilterHideCat.resolution = this.renderer.getResolution();
        this.glitchFilterSpawnNewCat = new GlitchFilter({ fillMode: GlitchFilter.TRANSPARENT, slices: 0, offset: 0 });
        this.glitchFilterSpawnNewCat.resolution = this.renderer.getResolution();
        this.helpText = TitanText.createField(this, this.landscapeProperties.helpText, this.portraitProperties.helpText);
        this.visible = false;
    }
    createCat() {
        const baseIndex = this.cats.length;
        const overFlowIndex = Math.floor(this.cats.length / this.uiProperties.catPositionsAndScales.length);
        const overFlowOffset = 45 * overFlowIndex;
        const positionIndex = baseIndex % this.uiProperties.catPositionsAndScales.length;
        const spine = TitanSpine.createSpine(undefined, "cat", this.landscapeProperties.siameseCat, this.portraitProperties.siameseCat);
        this.catSpaceContainer.addChildAt(spine, 0);
        spine.responsive = false;
        spine.play("idle", true, false, 0);
        const positionAndScale = this.uiProperties.catPositionsAndScales[positionIndex];
        spine.position.set(positionAndScale.position.x, positionAndScale.position.y);
        const targetDirection = positionAndScale.position.x > 0 ? 1 : -1;
        spine.position.x += (overFlowOffset * targetDirection);
        spine.scale.set(positionAndScale.scale.x, positionAndScale.scale.y);
        this.cats.push(spine);
        return spine;
    }
    createCounter(titleString, valueString) {
        const container = this.addChild(new Container());
        const title = container.addChild(new Text(titleString, new TextStyle({ fontFamily: "Arial", fontSize: 40, fill: 0xffffff })));
        const value = container.addChild(new Text(valueString, new TextStyle({ fontFamily: "Arial", fontSize: 40, fill: 0xffffff })));
        title.anchor.set(0.5);
        value.anchor.set(0.5);
        value.position.set(0, 50);
        return {
            container,
            title,
            value
        };
    }
    createParticleEmitter(landscapeProperties, portraitProperties) {
        const view = new AbstractGameView(this.factory, landscapeProperties, portraitProperties);
        this.addChild(view);
        const container = new LinkedListContainer();
        view.addChild(container);
        const particleEmitter = new ParticleEmitter(container, landscapeProperties);
        particleEmitter.stop();
        return { view, container, particleEmitter };
    }
    featurePresent() {
        this.helpText.alpha = 0;
        this.respinBackground.alpha = 0;
        this.clear();
        this.cats[0].play("idle", true, false, 0);
        this.prizeCat.play("idle", true, false, 0);
        this.prizeCat.getSpine(OrientationType.LANDSCAPE).state.tracks[0].alpha = 0.2;
        this.prizeCat.alpha = 1;
        this.reels.alpha = 0;
        this.paytableText.forEach(i => i.alpha = 0);
        this.paytableIcons.forEach(i => i.alpha = 0);
        this.helpButton.setEnabled(!Service.isReplay());
        this.balls.forEach(ball => {
            ball.visible = false;
            MouseUtil.setInteractive(ball, false);
        });
        this.visible = true;
    }
    start() {
    }
    clear() {
        this.balls.forEach(ball => ball.alpha = 0);
        this.visible = false;
        this.alpha = 1;
        this.respinState = RespinState.DISABLED;
        this.paytableWatchValue.alpha = 0;
        this.paytableSnuffboxValue.alpha = 0;
        this.paytableHairclipValue.alpha = 0;
        this.paytableTunaValue.alpha = 0;
        this.reels.clear();
        this.reels.clearLocks();
        this.balls.forEach(ball => {
            ball.visible = false;
            MouseUtil.setInteractive(ball, false);
        });
        this.winCount.setText(this.formatCurrency(0), true);
        this.spinCount.setText("8", true);
        this.cats.forEach((cat, index) => {
            if (index > 0) {
                cat.destroy();
            }
        });
        this.cats.length = 1;
        this.spinWinValue.setText("", true);
    }
    async gameIntro(event) {
        const baseGoldFish = event.getPayload().baseGoldFish;
        await Promise.all([
            this.fadeInReels(),
            this.fadeInPayLadder()
        ]);
        if (baseGoldFish > 1) {
            const newCat = this.createCat();
            newCat.alpha = 0;
            this.dispatchGame(GameClawpawtraSoundEvents.CAT_TELEPORT);
            newCat.play("duplicate", false, false, 0);
            SpineComplete(newCat).then(() => newCat.play("idle", true, false, 0));
            await glitchFadeIn(this.glitchFilterSpawnNewCat, newCat);
        }
        await this.introPickItems();
        this.dispatchGame(FeatureGoldFishEvents.PICKS_READY);
    }
    fadeInReels() {
        return gsap.timeline().to(this.reels, { alpha: 1, duration: 1, delay: 0.25 });
    }
    fadeInPayLadder() {
        const timeline = gsap.timeline();
        [...this.paytableText, ...this.paytableIcons].forEach((text, i) => {
            timeline.to(text, { alpha: 1, duration: 0.5 }, 0.25);
        });
        return timeline;
    }
    async introPickItems() {
        this.dispatchGame(GameClawpawtraSoundEvents.YARN_IN);
        const ballRippleTime = 0.16;
        let completePromises = [];
        for (const [index, ball] of this.balls.entries()) {
            if (index !== 0) {
                await delayFor(ballRippleTime);
            }
            ball.alpha = 1;
            ball.visible = true;
            ball.play("roll-in");
            ball.getSpine().update(0.01);
            completePromises.push(SpineComplete(ball));
        }
        await Promise.all(completePromises);
        gsap.to(this.helpText, {
            alpha: 1,
            duration: 0.5,
            delay: 5,
        });
        for (const ball of this.balls) {
            MouseUtil.setInteractive(ball, !Service.isReplay());
        }
    }
    revealPrizes(event) {
        const payload = event.getPayload();
        const index = payload["index"];
        const reward = payload["reward"];
        const spinCount = payload["spinCount"];
        const missedRewards = payload["missedRewards"];
        this.helpButton.setEnabled(false);
        gsap.killTweensOf(this.helpText);
        this.helpText.alpha = 0;
        const prizesAndBalls = this.balls.map((ball, i) => {
            return {
                ball,
                prize: i === index ? reward : missedRewards.pop(),
                picked: i === index
            };
        });
        const pickedBall = prizesAndBalls.filter(({ picked }) => picked)[0];
        const missedBalls = prizesAndBalls.filter(({ picked }) => !picked);
        gsap.delayedCall(0.75, () => this.dispatchGame(GameClawpawtraSoundEvents.PICK));
        const catAnim = [
            "slap1_l_end",
            "slap2_l_mid",
            "slap3_centre",
            "slap5_r_mid",
            "slap5_r_end",
        ][index];
        this.cats[0].play(catAnim, false, false, 0);
        SpineComplete(this.cats[0]).then(() => this.cats[0].play("idle", true, false, 0));
        const ballPrizeItems = prizesAndBalls.map(({ ball, prize, picked }, i) => {
            MouseUtil.setInteractive(ball, false);
            if (prize.type === "EXTRA_SPINS") {
                // text reward
                const properties = picked
                    ? [this.landscapeProperties.pickedPrize, this.portraitProperties?.pickedPrize]
                    : [this.landscapeProperties.missedPrize, this.portraitProperties?.missedPrize];
                const newPrizeText = TitanText.createField(null, `prize-${i}`, properties[0], properties[1]);
                newPrizeText.pivot.set(0, newPrizeText.getHeight() / 2);
                newPrizeText.setText(`+${prize.count}`, true);
                addToTitanSpineSlot(ball, newPrizeText, "dynamic-value");
                return newPrizeText;
            }
            else {
                getTitanSpineSlot(ball, "dynamic-value").mask = this.yarnMask.getPixiSprite();
                addToTitanSpineSlot(ball, this.yarnMask.getPixiSprite(), "dynamic-value");
                addToTitanSpineSlot(ball, this.prizeCat, "dynamic-value");
                return this.prizeCat;
            }
        });
        const timeline = gsap.timeline();
        timeline.add(() => {
            pickedBall.ball.play("selected_poof", false, false, 0);
        });
        timeline.add(gsap.delayedCall(2, () => {
            missedBalls.forEach(({ ball }) => {
                ball.play("reveal-missed-prize", false, false, 0);
            });
        }));
        timeline.add(gsap.delayedCall(2, () => {
            this.dispatchGame(GameClawpawtraSoundEvents.YARN_OUT);
            const hideCompletes = missedBalls.map(({ ball }) => {
                ball.play("hide-missed-prize", false, false, 0);
                return SpineComplete(ball);
            });
            Promise.all(hideCompletes).then(() => {
                missedBalls.forEach(({ ball }) => {
                    const slot = getTitanSpineSlot(ball, "dynamic-value");
                    slot.mask = null;
                });
                this.yarnMask.getPixiSprite().parent.removeChild(this.yarnMask.getPixiSprite());
                this.prizeCat.parent.removeChild(this.prizeCat);
                ballPrizeItems.filter((item, i) => i !== index).forEach(item => {
                    if (item instanceof TitanText) {
                        item.destroy();
                    }
                });
            });
            const pickedPrizeItem = ballPrizeItems[index];
            if (pickedPrizeItem instanceof TitanText) {
                this.dispatchGame(SoundEvent.BUBBLE_RISE);
                const delay = 0.5;
                const moveTime = 0.5;
                const maxScale = 1.1;
                const minScale = 0.4;
                const prizeText = pickedPrizeItem;
                const rawSpinCount = this.spinCount.getPixiText();
                const spinCountParent = rawSpinCount.parent;
                const spinCounterLocation = prizeText.parent.toLocal(spinCountParent.toGlobal(rawSpinCount.position));
                gsap.timeline()
                    .add(gsap.to(prizeText, {
                    x: spinCounterLocation.x - (prizeText.width * 0.4 / 2),
                    y: spinCounterLocation.y - (prizeText.height * 0.4 / 2),
                    duration: moveTime,
                    onStart: () => {
                        this.dispatchGame(GameClawpawtraSoundEvents.COLLECT_SPIN_PICK);
                    },
                    ease: "power1.inOut"
                }), delay)
                    .add(gsap.to(prizeText, {
                    pixi: {
                        scale: maxScale
                    },
                    ease: "circ.out",
                    duration: moveTime * 0.3
                }), delay)
                    .add(gsap.to(prizeText.getPixiText(), {
                    pixi: {
                        scale: minScale
                    },
                    ease: "circ.in",
                    duration: moveTime * 0.7
                }), delay + (moveTime * 0.3))
                    .add(() => {
                    this.collectSpinCountPick(spinCount);
                    prizeText.destroy();
                    this.dispatchGame(FeatureGoldFishEvents.REVEAL_PRIZES_COMPLETE);
                });
            }
            else if (pickedPrizeItem instanceof TitanSpine) {
                const newCat = this.createCat();
                newCat.alpha = 0;
                gsap.timeline()
                    .add(() => {
                    this.prizeCat.play("duplicate", false, false, 0);
                    this.prizeCat.getSpine(OrientationType.LANDSCAPE).state.tracks[0].alpha = 1;
                    this.dispatchGame(GameClawpawtraSoundEvents.CAT_TELEPORT);
                    glitchFadeOut(this.glitchFilterHideCat, this.prizeCat).then(() => {
                        this.prizeCat.alpha = 1;
                    });
                })
                    .add(gsap.delayedCall(1, () => {
                    newCat.play("duplicate", false, false, 0);
                    SpineComplete(newCat).then(() => newCat.play("idle", true, false, 0));
                    glitchFadeIn(this.glitchFilterSpawnNewCat, newCat);
                }))
                    .add(gsap.delayedCall(1, () => {
                    this.dispatchGame(FeatureGoldFishEvents.REVEAL_PRIZES_COMPLETE);
                }));
            }
        }));
    }
    moveToParentAtSameScreenPosition(object, newParent) {
        const localPosition = object.parent.toGlobal(object.position);
        newParent.addChild(object);
        object.position = newParent.toLocal(localPosition);
    }
    spin(e) {
        this.dispatchGame(SoundEvent.SPINS_LEFT);
        const payload = e.getPayload();
        const results = payload["results"];
        const payouts = payload["payouts"];
        const lockedReels = payload["lockedReels"];
        const spinType = payload["spinType"];
        if (spinType === "respin") {
            this.dispatchGame(GameClawpawtraSoundEvents.REEL_RESPIN);
        }
        else {
            this.dispatchGame(GameClawpawtraSoundEvents.REEL_SPIN);
        }
        this.reels.spin(results, payouts, lockedReels);
    }
    revealReelPayouts(e) {
        const payload = e.getPayload();
        const payouts = payload["payouts"];
        this.reels.revealPayouts(payouts);
    }
    collectReelPayout(e) {
        const payload = e.getPayload();
        const goldFishIndex = payload["goldFishIndex"];
        const reelPayouts = payload["reelPayouts"];
        const cumulativePayout = payload["cumulativePayout"];
        const payoutFrom = payload["payoutFrom"];
        const payoutTo = payload["payoutTo"];
        const isLast = payload["isLast"];
        const goldFishCount = payload["goldfishCount"];
        let count = 0;
        if (goldFishCount > 1 && !isLast) { // speed up collection for multiple goldfish
            const completeTime = goldFishIndex === 0 ? 0.9 : Math.max(0.25, 1.2 - Math.log(goldFishCount));
            gsap.timeline().add(() => {
                this.dispatchGame(FeatureGoldFishEvents.COLLECT_REEL_PAYOUT_COMPLETE);
            }, completeTime);
        }
        reelPayouts
            .map((payout, reelIndex) => ({ payout, reelIndex }))
            .filter(({ payout }) => payout > 0)
            .forEach(({ payout, reelIndex }, payoutIndex, payouts) => {
            const reelValue = this.reels.getReelPayoutTitanText(reelIndex);
            const parent = this.catSpaceOverlayContainer;
            const collectedValue = this.cloneTextInNewParent(reelValue, parent);
            // set the child indices to the reverse order to keep the first moving ontop to prevent popping with overlaps.
            if (payoutIndex > 0) {
                parent.setChildIndex(collectedValue, (parent.children.length - 1) - payoutIndex);
            }
            const activeCat = this.cats[goldFishIndex];
            const catPosition = activeCat.position.clone();
            const halfwayToCat = {
                x: TWEEN_TO_CAT_MIDPOINT.x + (catPosition.x - TWEEN_TO_CAT_MIDPOINT.x) / 2,
                y: TWEEN_TO_CAT_MIDPOINT.y + (catPosition.y - TWEEN_TO_CAT_MIDPOINT.y) / 2
            };
            const timeline = gsap.timeline();
            const collectRippleDelay = payoutIndex * 0.16;
            timeline.add(gsap.to(collectedValue, {
                motionPath: {
                    path: [
                        halfwayToCat,
                        catPosition
                    ],
                    curviness: 1.75,
                    fromCurrent: true
                },
                ease: "power1.inOut",
                duration: 1.5,
                onStart: () => {
                    if (payoutIndex === 0) {
                        activeCat.play("happy", false, false, 0);
                        SpineComplete(activeCat).then(() => {
                            activeCat.play("idle", true, false, 0);
                        });
                    }
                }
            }), collectRippleDelay);
            timeline.add(gsap.to(collectedValue, {
                pixi: {
                    scale: 0
                },
                duration: 0.6,
                ease: "power4.out",
                onStart: () => {
                    this.dispatchGame(GameClawpawtraSoundEvents.CASH_COLLECTED);
                    if (payoutIndex === 0) {
                        this.updateSpinWinValue(goldFishCount === 1 || isLast, payoutFrom, payoutTo, isLast, cumulativePayout);
                    }
                }
            }), "-=0.5");
            timeline.add(() => {
                collectedValue.destroy();
            });
            if (isLast) {
                this.reels.hidePayout(reelIndex);
            }
        });
    }
    updateSpinWinValue(shouldNotify, from, to, collect, cumulativePayout) {
        this.spinWinValue.setText(this.formatCurrency(from), true);
        const timeline = gsap.timeline();
        if (from === 0) {
            this.spinWinValue.getPixiText()?.scale.set(0);
        }
        const duration = 0.6;
        const maxScale = 1.3;
        const payout = { value: from };
        gsap.to(payout, {
            value: to,
            duration: duration / 2,
            overwrite: true,
            onUpdate: () => {
                this.spinWinValue.setText(this.formatCurrency(payout.value), true);
            }
        });
        timeline.add(gsap.to(this.spinWinValue.getPixiText(), {
            pixi: {
                scale: maxScale
            },
            ease: "circ.out",
            duration: duration / 2,
        }));
        timeline.add(gsap.to(this.spinWinValue.getPixiText(), {
            pixi: {
                scale: 1
            },
            ease: "circ.in",
            duration: duration / 2,
        }));
        timeline.add(() => {
            if (!collect) {
                return;
            }
            if (shouldNotify) {
                this.dispatchGame(FeatureGoldFishEvents.COLLECT_REEL_PAYOUT_COMPLETE);
            }
            this.spinWinValue.setText(this.formatCurrency(to), true);
            if (collect) {
                this.collectSpinWinValueToCounter(cumulativePayout);
            }
        });
    }
    collectSpinWinValueToCounter(cumulativePayout) {
        const spinValueClone = this.spinWinValue.clone();
        this.spinWinValue.setText("");
        const winCounterLocation = this.toLocal(this.winCount.parent.toGlobal(this.winCount.position));
        const moveTime = 0.5;
        const maxScale = 1.1;
        const minScale = 0.4;
        gsap.timeline()
            .add(gsap.to(spinValueClone, {
            x: winCounterLocation.x - (spinValueClone.width * minScale / 2),
            y: winCounterLocation.y - (spinValueClone.height * minScale / 2),
            duration: moveTime,
            ease: "power1.inOut"
        }))
            .add(gsap.to(spinValueClone.getPixiText(), {
            pixi: {
                scale: maxScale
            },
            ease: "circ.out",
            duration: moveTime * 0.3
        }), 0)
            .add(gsap.to(spinValueClone.getPixiText(), {
            pixi: {
                scale: minScale
            },
            ease: "circ.in",
            duration: moveTime * 0.7
        }), moveTime * 0.3)
            .add(() => {
            spinValueClone.destroy();
            this.collectSpinWin(cumulativePayout);
        });
    }
    goldFishCollectedFromReel(event) {
        const reelIndex = event.getPayload()["reelIndex"];
        const newCat = this.createCat();
        newCat.alpha = 0;
        const reelCat = this.reels.getReelSymbol(reelIndex);
        gsap.timeline().add(() => {
            this.dispatchGame(GameClawpawtraSoundEvents.CAT_TELEPORT);
            reelCat.getChildAt(0)?.collectGold();
            glitchFadeOut(this.glitchFilterHideCat, reelCat).then(() => {
                reelCat.alpha = 1;
                this.reels.hideReelSymbol(reelIndex);
            });
        }).add(gsap.delayedCall(1, () => {
            newCat.play("duplicate", false, false, 0);
            SpineComplete(newCat).then(() => newCat.play("idle", true, false, 0));
            glitchFadeIn(this.glitchFilterSpawnNewCat, newCat);
        })).add(gsap.delayedCall(1, () => {
            this.dispatchGame(FeatureGoldFishEvents.COLLECT_CAT_FROM_REEL_COMPLETE);
        }));
    }
    updateSpinCount(e) {
        const payload = e.getPayload();
        const count = payload["count"];
        this.spinCount.setText(count.toString(), true);
    }
    collectSpinWin(winCount) {
        this.dispatchGame(SoundEvent.BANGUP_GOLD_FISH_END);
        this.winCount.setText(this.formatCurrency(winCount), true);
        gsap.to(this.winCount.getPixiText(), {
            pixi: {
                scale: 0.9
            },
            ease: "circ.in",
            yoyoEase: "circ.out",
            yoyo: true,
            repeat: 1,
            duration: 0.13
        });
    }
    collectSpinCountPick(spinCount) {
        const currentCount = parseInt(this.spinCount.getText());
        const target = { value: currentCount };
        gsap.to(target, {
            value: spinCount,
            duration: 0.33,
            onUpdate: () => this.spinCount.setText(Math.floor(target.value).toString(), true),
            onComplete: () => this.spinCount.setText(spinCount.toString(), true)
        });
        gsap.to(this.spinCount.getPixiText(), {
            pixi: {
                scale: 0.9
            },
            ease: "circ.in",
            yoyoEase: "circ.out",
            yoyo: true,
            repeat: 1,
            duration: 0.13
        });
    }
    updateWinCount(e) {
        const payload = e.getPayload();
        const count = payload["count"];
        this.winCount.setText(this.formatCurrency(count));
    }
    enableLocks(event) {
        const payload = event.getPayload();
        const lockingReels = payload["lockingReels"];
        this.reels.enableLocks(lockingReels);
        if (lockingReels.length > 0) {
            this.dispatchGame(SoundEvent.GOLDFISH_LOCK_REELS);
        }
        gsap.to(this.spinCount, {
            alpha: 0.7,
            duration: 0.25
        });
    }
    clearLocks() {
        gsap.to(this.spinCount, {
            alpha: 1,
            duration: 0.25
        });
        this.reels.clearLocks();
    }
    collectBlueFishFromReel(event) {
        const payload = event.getPayload();
        const reelIndex = payload["reelIndex"];
        const multiplier = payload["multiplier"];
        const isLast = payload["isLast"];
        const timeline = gsap.timeline();
        timeline.add("hideSymbol", 0);
        timeline.add("trailStart", 0);
        timeline.add("trailImpact", 0.24);
        timeline.add("trailComplete", 1);
        timeline.add("watchRevealed", 1.34);
        timeline.add(() => {
            this.reels.hideReelSymbol(reelIndex);
        }, "hideSymbol");
        if (multiplier === 1) {
            this.performRespinTransitionTo(timeline, reelIndex);
        }
        else {
            this.performRespinMultiplierUpdate(timeline, reelIndex, multiplier, !isLast);
        }
        timeline.play();
    }
    performRespinTransitionTo(timeline, reelIndex) {
        const starBurstDuration = 1;
        const starBurstMoveDelay = 0.2;
        // begin the transition
        timeline.add(() => {
            this.dispatchGame(FeatureGoldFishEvents.RESPIN_TRANSITION_TO);
            this.respinState = RespinState.TRANSITIONING_IN;
        }, "trailStart");
        // move reels into position
        timeline.add(gsap.to(this.reels, {
            y: this.uiProperties.respinReelPosition.y,
            duration: starBurstDuration - starBurstMoveDelay,
            ease: "power1.inOut",
        }), "trailStart");
        // move paytable into position
        [...this.paytableIcons, ...this.paytableText].forEach(item => {
            timeline.add(gsap.to(item, {
                x: item.x + this.uiProperties.respinPaytableOffset.x,
                y: item.y + this.uiProperties.respinPaytableOffset.y,
                duration: starBurstDuration - starBurstMoveDelay,
                ease: "power1.inOut"
            }), "trailStart");
        });
        // do the trail
        this.respinTrail(timeline, reelIndex);
        // show the watch
        timeline.add(() => {
            this.respinWatch.scale.copyFrom(this.uiProperties.respinWatch.scale);
            this.respinWatch.visible = true;
            this.dispatchGame(GameClawpawtraSoundEvents.RESPIN_TRIGGER);
            SpineUtil.play(this.respinWatch, "respin-intro", () => {
                SpineUtil.playLoop(this.respinWatch, "idle");
            });
            this.respinWatch.getSpine().update(0.1);
            gsap.to(this.respinBackground, {
                alpha: 1,
                duration: 1
            });
        }, "trailImpact");
        // show the title
        timeline.add(gsap.to(this.respinTitle, {
            alpha: 1,
            duration: 0.5
        }), "trailComplete");
        timeline.add(() => {
            this.respinState = RespinState.ENABLED;
            this.dispatchGame(FeatureGoldFishEvents.COLLECT_WATCH_FROM_REEL_COMPLETE);
        }, "watchRevealed");
    }
    timelineDelay(timeline, time) {
        timeline.add(() => { }, `+=${time}`);
    }
    performRespinMultiplierUpdate(timeline, reelIndex, multiplier, isNotLast) {
        this.respinTrail(timeline, reelIndex);
        timeline.add(() => {
            this.dispatchGame(GameClawpawtraSoundEvents.RESPIN_MULTIPLIER_INCREASE);
            SpineUtil.play(this.respinWatch, "respin-retrigger2", () => {
                SpineUtil.playLoop(this.respinWatch, "idle");
            });
            this.respinWatch.getSpine().update(0.1);
        }, "trailImpact");
        const multiplierRevealDuration = 0.5;
        timeline.add(gsap.to(this.respinMultiplierBackground, {
            pixi: { scale: 1.2 * this.uiProperties.respinMultiplierBackground.scale.x },
            duration: multiplierRevealDuration * 0.6,
            ease: "power1.out",
            onStart: () => {
                if (multiplier === 2) { // first time it's visible, do the reveal
                    this.respinMultiplierValue.setText(`X${multiplier}`, true);
                    this.respinMultiplierBackground.scale.set(0);
                    this.respinMultiplierBackground.visible = true;
                }
            },
            onComplete: () => {
                this.dispatchGame(new EventObject(SoundEvent.GOLDFISH_MULTIPLIER.getType(), { multiplier }));
                if (multiplier > 2) {
                    this.respinMultiplierValue.setText(`X${multiplier}`, true);
                }
            }
        }), "trailImpact");
        timeline.add(gsap.to(this.respinMultiplierBackground, {
            pixi: { scale: this.uiProperties.respinMultiplierBackground.scale.x },
            ease: "power1.in",
            duration: multiplierRevealDuration * 0.4
        }));
        timeline.add(() => {
            this.dispatchGame(FeatureGoldFishEvents.COLLECT_WATCH_FROM_REEL_COMPLETE);
        }, "trailComplete");
    }
    respinTrail(timeline, fromReelIndex) {
        const startPositionGlobal = this.reels.getReelCenterPosition(fromReelIndex);
        const trail = new Trail(this.factory, this.landscapeProperties.respinTrailSpine, this.portraitProperties.respinTrailSpine);
        this.addChild(trail);
        timeline.add(() => {
            this.dispatchGame(GameClawpawtraSoundEvents.RESPIN_TRAIL_SWOOSH);
            trail.play(startPositionGlobal, this.toGlobal(this.respinWatch.position));
        }, "trailStart");
    }
    exitRespins() {
        const labelImmediately = "immediately";
        const labelSecondaryMotion = "secondaryMovement";
        const timeline = gsap.timeline();
        timeline.addLabel(labelImmediately);
        timeline.add(() => {
            this.respinState = RespinState.TRANSITIONING_OUT;
            this.clearLocks();
        }, labelImmediately);
        timeline.add(gsap.to(this.respinMultiplierBackground, {
            pixi: { scale: 0 },
            ease: "power1.in",
            duration: 0.5,
            onComplete: () => {
                this.respinMultiplierBackground.visible = false;
            }
        }), labelImmediately);
        timeline.add(gsap.to(this.respinBackground, {
            alpha: 0,
            duration: 1
        }), labelImmediately);
        timeline.add(gsap.to(this.respinWatch, {
            pixi: { scale: 0 },
            ease: "power1.in",
            duration: 0.5,
            onComplete: () => {
                this.respinWatch.visible = false;
            }
        }), labelImmediately);
        timeline.add(gsap.to(this.respinTitle, {
            alpha: 0,
            duration: 0.5
        }), labelImmediately);
        this.timelineDelay(timeline, 0.3);
        timeline.addLabel(labelSecondaryMotion);
        timeline.add(() => this.dispatchGame(FeatureGoldFishEvents.RESPIN_TRANSITION_FROM), labelSecondaryMotion);
        [...this.paytableIcons, ...this.paytableText].forEach(item => {
            timeline.add(gsap.to(item, {
                x: item.x - this.uiProperties.respinPaytableOffset.x,
                y: item.y - this.uiProperties.respinPaytableOffset.y,
                duration: 0.5,
                ease: "power1.inOut"
            }), labelSecondaryMotion);
        });
        timeline.add(gsap.to(this.reels, {
            y: this.uiProperties.reelsProperties.position.y,
            duration: 0.5,
            ease: "power1.inOut"
        }), labelSecondaryMotion);
        timeline.add(() => this.respinState = RespinState.DISABLED);
        this.timelineDelay(timeline, 0.5);
        timeline.add(() => this.dispatchGame(FeatureGoldFishEvents.EXIT_RESPINS_COMPLETE));
    }
    distributeMultiplier(event) {
        const payload = event.getPayload();
        const unmultipliedPayouts = payload.unmultipliedPayout;
        const multipliedPayouts = payload.multipliedPayout;
        const timeline = gsap.timeline();
        this.dispatchGame(SoundEvent.BANGUP_BLUE_FISH_START);
        unmultipliedPayouts
            .map((_, index) => ({ unmultipliedPayout: unmultipliedPayouts[index], multipliedPayout: multipliedPayouts[index], reelIndex: index }))
            .filter(({ multipliedPayout }) => multipliedPayout > 0)
            .forEach(({ unmultipliedPayout, multipliedPayout, reelIndex }) => {
            const duration = 0.5;
            timeline.add(() => {
                const multiplierValueClone = this.cloneTextInNewParent(this.respinMultiplierValue, this);
                const payoutPosition = this.toLocal(this.reels.getGlobalReelPayoutPosition(reelIndex));
                this.dispatchGame(GameClawpawtraSoundEvents.APPLY_MULTIPLIER);
                gsap.to(multiplierValueClone, {
                    x: payoutPosition.x,
                    ease: "linear",
                    duration,
                });
                gsap.to(multiplierValueClone, {
                    y: payoutPosition.y,
                    ease: "power1.in",
                    duration,
                    onComplete: () => {
                        multiplierValueClone.destroy();
                        this.reels.applyPayoutMultiplier(reelIndex, unmultipliedPayout, multipliedPayout);
                    }
                });
            });
            this.timelineDelay(timeline, duration);
        });
        this.timelineDelay(timeline, 0.6);
        timeline.add(() => {
            this.dispatchGame(SoundEvent.BANGUP_BLUE_FISH_END);
            this.dispatchGame(FeatureGoldFishEvents.DISTRIBUTE_MULTIPLIER_COMPLETE);
        });
    }
    cloneTextInNewParent(object, parent) {
        const clone = object.clone();
        parent.addChild(clone);
        clone.position.copyFrom(parent.toLocal(object.parent.toGlobal(object.position)));
        clone.scale.set(1);
        clone.updateTransform();
        clone.scale.set(object.worldTransform.a / clone.worldTransform.a);
        clone.pivot.set(object.pivot.x, object.pivot.y);
        return clone;
    }
    handleRotate(event) {
        super.handleRotate(event);
        this.respinMultiplierBackground.visible = [RespinState.ENABLED, RespinState.TRANSITIONING_IN].includes(this.respinState);
        this.respinWatch.visible = [RespinState.ENABLED, RespinState.TRANSITIONING_IN].includes(this.respinState);
        this.reels.alpha = 1;
        const reelMoveTween = gsap.getTweensOf(this.reels)[0];
        if (reelMoveTween !== undefined) {
            if ([RespinState.ENABLED, RespinState.TRANSITIONING_IN].includes(this.respinState)) {
                this.reels.position.copyFrom(this.uiProperties.respinReelPosition);
                reelMoveTween.vars.y = this.uiProperties.respinReelPosition.y;
            }
            else {
                this.reels.position.copyFrom(this.uiProperties.reelsProperties.position);
                reelMoveTween.vars.y = this.uiProperties.respinReelPosition.y;
            }
            const progress = reelMoveTween.progress();
            reelMoveTween.invalidate().restart().progress(progress);
        }
        else {
            if ([RespinState.ENABLED, RespinState.TRANSITIONING_IN].includes(this.respinState)) {
                this.reels.position.copyFrom(this.uiProperties.respinReelPosition);
            }
            else {
                this.reels.position.copyFrom(this.uiProperties.reelsProperties.position);
            }
        }
        this.paytableIcons.forEach((icon, index) => {
            gsap.killTweensOf(icon);
            if ([RespinState.ENABLED, RespinState.TRANSITIONING_IN].includes(this.respinState)) {
                icon.position.set(this.uiProperties.paytableIcons[index].position.x + this.uiProperties.respinPaytableOffset.x, this.uiProperties.paytableIcons[index].position.y + this.uiProperties.respinPaytableOffset.y);
            }
            else {
                icon.position.set(this.uiProperties.paytableIcons[index].position.x, this.uiProperties.paytableIcons[index].position.y);
            }
        });
        this.paytableText.forEach(text => gsap.killTweensOf(text));
        if ([RespinState.ENABLED, RespinState.TRANSITIONING_IN].includes(this.respinState)) {
            this.paytableWatchValue.position.set(this.uiProperties.payTableValueWatch.position.x + this.uiProperties.respinPaytableOffset.x, this.uiProperties.payTableValueWatch.position.y + this.uiProperties.respinPaytableOffset.y);
            this.paytableSnuffboxValue.position.set(this.uiProperties.payTableValueSnuffbox.position.x + this.uiProperties.respinPaytableOffset.x, this.uiProperties.payTableValueSnuffbox.position.y + this.uiProperties.respinPaytableOffset.y);
            this.paytableHairclipValue.position.set(this.uiProperties.payTableValueHairclip.position.x + this.uiProperties.respinPaytableOffset.x, this.uiProperties.payTableValueHairclip.position.y + this.uiProperties.respinPaytableOffset.y);
            this.paytableTunaValue.position.set(this.uiProperties.payTableValueTuna.position.x + this.uiProperties.respinPaytableOffset.x, this.uiProperties.payTableValueTuna.position.y + this.uiProperties.respinPaytableOffset.y);
        }
        else {
            this.paytableWatchValue.position.copyFrom(this.uiProperties.payTableValueWatch.position);
            this.paytableSnuffboxValue.position.copyFrom(this.uiProperties.payTableValueSnuffbox.position);
            this.paytableHairclipValue.position.copyFrom(this.uiProperties.payTableValueHairclip.position);
            this.paytableTunaValue.position.copyFrom(this.uiProperties.payTableValueTuna.position);
        }
        this.catSpaceContainer.position.set(this.uiProperties.catSpaceContainerPosition.x, this.uiProperties.catSpaceContainerPosition.y);
        this.catSpaceContainer.scale.set(this.uiProperties.catSpaceContainerScale.x, this.uiProperties.catSpaceContainerScale.y);
        this.catSpaceOverlayContainer.position.set(this.uiProperties.catSpaceContainerPosition.x, this.uiProperties.catSpaceContainerPosition.y);
        this.catSpaceOverlayContainer.scale.set(this.uiProperties.catSpaceContainerScale.x, this.uiProperties.catSpaceContainerScale.y);
        for (const ball of this.balls) {
            updateResponsiveSpineSlotsChildren(ball);
        }
    }
    handleResize(event) {
        super.handleResize(event);
        this.catSpaceContainer.position.set(this.uiProperties.catSpaceContainerPosition.x, this.uiProperties.catSpaceContainerPosition.y);
        this.catSpaceContainer.scale.set(this.uiProperties.catSpaceContainerScale.x, this.uiProperties.catSpaceContainerScale.y);
        this.catSpaceOverlayContainer.position.set(this.uiProperties.catSpaceContainerPosition.x, this.uiProperties.catSpaceContainerPosition.y);
        this.catSpaceOverlayContainer.scale.set(this.uiProperties.catSpaceContainerScale.x, this.uiProperties.catSpaceContainerScale.y);
    }
}
FeatureGoldFish.REPLAY_PICK_INDEX = 2;
export class FeatureGoldFishEvents {
}
FeatureGoldFishEvents.FEATURE_PRESENT = new EventObject("FeatureGoldFishEvents.FEATURE_PRESENT");
FeatureGoldFishEvents.START = new EventObject("FeatureGoldFishEvents.START");
FeatureGoldFishEvents.START_GAME_INTRO = new EventObject("FeatureGoldFishEvents.FISH_ENTER_BOWL");
FeatureGoldFishEvents.PICKS_READY = new EventObject("FeatureGoldFishEvents.PICKS_READY");
FeatureGoldFishEvents.PICK_SELECTED = new EventObject("FeatureGoldFishEvents.PICK_SELECTED");
FeatureGoldFishEvents.REVEAL_PRIZES = new EventObject("FeatureGoldFishEvents.REVEAL_PRIZES");
FeatureGoldFishEvents.REVEAL_PRIZES_COMPLETE = new EventObject("FeatureGoldFishEvents.REVEAL_PRIZES_COMPLETE");
FeatureGoldFishEvents.SPIN = new EventObject("FeatureGoldFishEvents.SPIN");
FeatureGoldFishEvents.SPIN_ANIMATION_COMPLETE = new EventObject("FeatureGoldFishEvents.SPIN_ANIMATION_COMPLETE");
FeatureGoldFishEvents.REVEAL_REEL_PAYOUTS = new EventObject("FeatureGoldFishEvents.REVEAL_REEL_VALUES");
FeatureGoldFishEvents.COLLECT_REEL_PAYOUT = new EventObject("FeatureGoldFishEvents.COLLECT_REEL_PAYOUT");
FeatureGoldFishEvents.COLLECT_REEL_PAYOUT_COMPLETE = new EventObject("FeatureGoldFishEvents.COLLECT_REEL_PAYOUT_COMPLETE");
FeatureGoldFishEvents.COLLECT_CAT_FROM_REEL = new EventObject("FeatureGoldFishEvents.COLLECT_CAT_FROM_REEL");
FeatureGoldFishEvents.COLLECT_CAT_FROM_REEL_COMPLETE = new EventObject("FeatureGoldFishEvents.COLLECT_CAT_FROM_REEL_COMPLETE");
FeatureGoldFishEvents.COLLECT_WATCH_FROM_REEL = new EventObject("FeatureGoldFishEvents.COLLECT_WATCH_FROM_REEL");
FeatureGoldFishEvents.COLLECT_WATCH_FROM_REEL_COMPLETE = new EventObject("FeatureGoldFishEvents.COLLECT_WATCH_FROM_REEL_COMPLETE");
FeatureGoldFishEvents.DISTRIBUTE_MULTIPLIER = new EventObject("FeatureGoldFishEvents.DISTRIBUTE_MULTIPLIER");
FeatureGoldFishEvents.DISTRIBUTE_MULTIPLIER_COMPLETE = new EventObject("FeatureGoldFishEvents.DISTRIBUTE_MULTIPLIER_COMPLETE");
FeatureGoldFishEvents.EXIT_RESPINS = new EventObject("FeatureGoldFishEvents.EXIT_RESPINS");
FeatureGoldFishEvents.EXIT_RESPINS_COMPLETE = new EventObject("FeatureGoldFishEvents.EXIT_RESPINS_COMPLETE");
FeatureGoldFishEvents.ENABLE_LOCKS = new EventObject("FeatureGoldFishEvents.ENABLE_LOCKS");
FeatureGoldFishEvents.CLEAR_LOCKS = new EventObject("FeatureGoldFishEvents.CLEAR_LOCKS");
FeatureGoldFishEvents.UPDATE_SPIN_COUNT = new EventObject("FeatureGoldFishEvents.UPDATE_SPIN_COUNT");
FeatureGoldFishEvents.UPDATE_WIN_COUNT = new EventObject("FeatureGoldFishEvents.UPDATE_WIN_COUNT");
FeatureGoldFishEvents.CLEAR = new EventObject("FeatureGoldFishEvents.CLEAR");
FeatureGoldFishEvents.RESPIN_TRANSITION_TO = new EventObject("FeatureGoldFishEvents.RESPIN_TRANSITION_TO");
FeatureGoldFishEvents.RESPIN_TRANSITION_TO_COMPLETE = new EventObject("FeatureGoldFishEvents.RESPIN_TRANSITION_TO_COMPLETE");
FeatureGoldFishEvents.RESPIN_TRANSITION_FROM = new EventObject("FeatureGoldFishEvents.RESPIN_TRANSITION_FROM");
FeatureGoldFishEvents.RESPIN_TRANSITION_FROM_COMPLETE = new EventObject("FeatureGoldFishEvents.RESPIN_TRANSITION_FROM_COMPLETE");
//# sourceMappingURL=FeatureGoldFish.js.map